import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'
import { useAuth } from 'context/auth'

export const useDatadogUser = (): void => {
  const { userEmail, currentAccount } = useAuth()
  const accountId = currentAccount?.accountId
  const premiseId = currentAccount?.premiseId

  useEffect(() => {
    if (process.env.REACT_APP_DD_RUM_ENABLED !== 'true') return

    if (userEmail && accountId) {
      datadogRum.setUser({
        id: accountId,
        email: userEmail
      })
      datadogRum.setUserProperty('account_id', accountId)
      datadogRum.setUserProperty('premise_id', premiseId)
      datadogRum.setUserProperty('tenant', 'delco')
    } else {
      datadogRum.clearUser()
    }

    return () => {
      datadogRum.clearUser()
    }
  }, [userEmail, accountId, premiseId])
}
